/* tslint:disable */
/* eslint-disable */
/**
 * crm-campaigns
 * crm-campaigns
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CrmReferralSourcesPage } from './CrmReferralSourcesPage';
import {
    CrmReferralSourcesPageFromJSON,
    CrmReferralSourcesPageFromJSONTyped,
    CrmReferralSourcesPageToJSON,
} from './CrmReferralSourcesPage';

/**
 * 
 * @export
 * @interface FindAllCrmContactsReferralSources200Response
 */
export interface FindAllCrmContactsReferralSources200Response {
    /**
     * 
     * @type {CrmReferralSourcesPage}
     * @memberof FindAllCrmContactsReferralSources200Response
     */
    data?: CrmReferralSourcesPage;
}

/**
 * Check if a given object implements the FindAllCrmContactsReferralSources200Response interface.
 */
export function instanceOfFindAllCrmContactsReferralSources200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllCrmContactsReferralSources200ResponseFromJSON(json: any): FindAllCrmContactsReferralSources200Response {
    return FindAllCrmContactsReferralSources200ResponseFromJSONTyped(json, false);
}

export function FindAllCrmContactsReferralSources200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllCrmContactsReferralSources200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : CrmReferralSourcesPageFromJSON(json['data']),
    };
}

export function FindAllCrmContactsReferralSources200ResponseToJSON(value?: FindAllCrmContactsReferralSources200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CrmReferralSourcesPageToJSON(value.data),
    };
}

